export default "__VITE_ASSET__4nEdQKoM__"